/*
  replaceByObject
  Replaces instances of keys from mapObj in str with the respective values
  e.g.
  replaceByObject('Hello :name', {name: 'Bob'}) => Hello Bob
*/
interface Replacements {
  [index: string | number]: string | number
}

export const replaceByObject = (str: string, mapObj: Replacements) => {
  const regEx = new RegExp(Object.keys(mapObj).map(k => `:${k}`).join('|'), 'gi');

  return str.replace(regEx, matched => `${mapObj[matched.replace(':', '')]}`);
};
